import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import BatchRegistration from "./BatchRegistration.js";
import BatchAssigning from "./BatchAssigning.js";

// @material-ui/icons components
import School from "@material-ui/icons/School";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";

import { Typography } from "@material-ui/core";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function Delete() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const [courses, setcourses] = useState([]);
  const [usernames, setusernames] = useState([]);
  const [alertText, setalertText] = useState("");
  const [loading, setLoading] = useState(true);
  const [form, setform] = useState({
    courseId: 0,
    batchName: "",
    batch_teacher: "",
  });

  //text fields changes
  const handleChange = (e) => {
    setalertText("");
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fetchCourses = async () => {
    var token = localStorage.getItem("token");
    try {
      const res = await fetch("https://server.thelanofficial.com/Get-Courses", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
        }),
      });

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await res.json();

      if (data.valid === false) {
        return;
      } else if (data.valid === true) {
        setcourses(data.result);

        setLoading(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  const fetchUsernames = async () => {
    var token = localStorage.getItem("token");
    try {
      const res = await fetch(
        "https://server.thelanofficial.com/Get-Users-All",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
          }),
        }
      );

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await res.json();

      if (data.valid === false) {
        return;
      } else if (data.valid === true) {
        setusernames(data.users);

        setLoading(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  const ChangeCLick1 = () => {
    if (
      ["courseId", "batchName", "batch_teacher"].some(
        (field) => form[field] === ""
      )
    ) {
      setalertText("please fill all the fields");
      return;
    }

    var token = localStorage.getItem("token");

    const fetchCreate = async () => {
      try {
        const res = await fetch(
          "https://server.thelanofficial.com/Start-Batch",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              courseId: form.courseId,
              batchName: form.batchName,
              batch_teacher: form.batch_teacher,
              token,
            }),
          }
        );

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setalertText(data.message);
        } else if (data.valid === true) {
          setform((prev) => ({
            ...prev,
            [form.password]: "",
          }));
          setalertText(data.message);
          fetchCourses();
        }

        window.location.reload();

      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchCreate();
  };

  useEffect(() => {
    var token = localStorage.getItem("token");

    const fetchData = async () => {
      try {
        const res = await fetch(
          "https://server.thelanofficial.com/validate-token",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ token }),
          }
        );

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchData();
    fetchUsernames();
    fetchCourses();
  }, []);

  return (
    <>
      <Box component={Grid} container justifyContent="center" spacing={2}>
        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  START BATCH
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            />
            <CardContent classes={{ root: classes.cardContent }}>
              <Box
                color={theme.palette.gray[600]}
                textAlign="center"
                marginBottom="1.5rem"
                marginTop=".5rem"
                fontSize="1rem"
              >
                <Box fontSize="80%" fontWeight="400" component="small">
                  Select teacher and fill in course name and description
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  width: "50%",
                  marginLeft: "26%",
                }}
              >
                <FormControl variant="outlined" fullWidth>
                  {loading ? (
                    <Typography>Loading...</Typography>
                  ) : (
                    <Select
                      placeholder="ROLE"
                      name="courseId"
                      defaultValue=""
                      onChange={handleChange}
                      IconComponent={KeyboardArrowDown}
                    >
                      <MenuItem value="" disabled>
                        Select a course
                      </MenuItem>
                      {courses.map((key, index) => (
                        <MenuItem key={index} value={courses[index].course_id}>
                          {courses[index].course_id} -{" "}
                          {courses[index].course_name} - {courses[index].status}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </FormControl>
                <FormControl variant="outlined" fullWidth>
                  {loading ? (
                    <Typography>Loading...</Typography>
                  ) : (
                    <Select
                      placeholder="ROLE"
                      name="batch_teacher"
                      defaultValue=""
                      onChange={handleChange}
                      IconComponent={KeyboardArrowDown}
                    >
                      <MenuItem value="" disabled>
                        Select a teacher
                      </MenuItem>

                      {
                usernames.map((key, index) =>
                  usernames[index].role === "teacher" ? (
                    <MenuItem
                      key={index}
                      value={usernames[index].user_id}
                    >
                     {usernames[index].user_id} - {usernames[index].username} - {usernames[index].first_name}  {usernames[index].last_name}
                    </MenuItem>
                  ) : null
                )}
                    </Select>
                  )}
                   
                </FormControl>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    name="batchName"
                    value={form.batchName}
                    onChange={handleChange}
                    placeholder="Batch Name"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <Box
                fontStyle="italic"
                fontSize="1rem"
                color={theme.palette.gray[600]}
                marginBottom=".5rem"
              >
                <Box component="small" fontSize="80%">
                  <Box
                    component="span"
                    fontWeight="700"
                    color={theme.palette.success.main}
                  />
                </Box>
              </Box>

              <Typography
                style={{
                  color: alertText === "New batch started" ? "green" : "red",
                  fontSize: "10px",
                }}
              >
                {alertText}
              </Typography>
              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                <Button
                  onClick={ChangeCLick1}
                  variant="contained"
                  classes={{ root: classes.buttonContainedInfo }}
                >
                  Start Batch
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  STUDENT ENROLLMENT
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            />
            <CardContent classes={{ root: classes.cardContent }}>
              <BatchRegistration style={{ width: "100%" }} />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  ASSIGN ANOTHER TEACHER
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            />
            <CardContent classes={{ root: classes.cardContent }}>
              <BatchAssigning style={{ width: "100%" }} />
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </>
  );
}

export default Delete;
